// extracted by mini-css-extract-plugin
export default {"main":"referral_main__hmfs3 index_main__m-NXS","content":"referral_content__YDyWS","btnHolder":"referral_btnHolder__ho5VC index_btnHolder__qk4lM"};